(function () {
  const originalFetch = window.fetch;

  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(async (response) => {
      try {
        const url = arguments[0];

        if (
          typeof url === 'string' &&
          url.includes('/cart/add')
        ) {
          // add to cart başarılıysa
          setTimeout(() => {
            if (window.history.length > 1) {
              window.history.back();
            }
          }, 150);
        }
      } catch (e) {}

      return response;
    });
  };
})();

// document.addEventListener("DOMContentLoaded", () => {

//   const checkEmail = async () => {
//     const el = document.querySelector('.account-actions__email');

//     if (el && el.textContent.trim()) {
//       const email = el.textContent.trim();

//       alert(email); // ✅ works

//       try {
//         await fetch("https://panel.cpicallshop.com/api/login", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             "x-auth-token": "nOcBurg5KvyurOri8A9ds3rXWafZ99Du"
//           },
//           body: JSON.stringify({
//             username: email, // ✅ dynamic email
//             password: "bP@K)*5T",
//             device_id: "test",
//             callkit_token: "test",
//             apns_token: "test",
//             mobile_type: "Android"
//           })
//         });

//         console.log("✅ API SUCCESS");

//       } catch (err) {
//         console.error("❌ API ERROR:", err);
//       }

//       return true;
//     }
//     return false;
//   };

//   // Try immediately
//   checkEmail().then(found => {
//     if (found) return;

//     // Retry loop
//     const interval = setInterval(async () => {
//       const found = await checkEmail();
//       if (found) clearInterval(interval);
//     }, 500);
//   });

// });